import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import PlayerAudio from '../Players/PlayerAudio';
import PlayerVideo from '../Players/PlayerVideo';
import SvgMiniAudio from '../Svg/SvgMiniAudio';
import SvgMiniPlayerPause from '../Svg/SvgMiniPlayerPause';
import SvgArrow from '../Svg/SvgArrow';
import Animation from '../../helpers/animation';
import Volume from '../../containers/Volume';
import './index.css';
import { getAudioStreams, getSocialLinks, getSongPicture } from './requests';
import {
  changeAudioFlowAction,
  changeFlowAction,
  pauseAudioPlaybackAction,
  playAudioPlaybackAction,
  setStreamName,
  setCurrentArtist,
  setCurrentSong,
  setCurrentCover,
  setLastListenedStream,
  setMenuOpen
} from '../../redux/actions';

export default function BlockPlayer({ open }) {
  const dispatch = useDispatch();
  const { audioPlayback, flow, flowsInfo, lastListenedStream, isMenuOpen } = useSelector((state) => state);
  const [activeFlow, setActiveFlow] = useState({});
  const [playerBurger, setPlayerBurger] = useState('');
  const [playingStation, setplayingStation] = useState('sa_1');
  // const [currentArtist, setCurrentArtist] = useState("");
  // const [currentSong, setCurrentSong] = useState("");
  // const [currentCover, setCurrentCover] = useState("");
  const [socialLinks, setSocialLinks] = useState([]);

  const [openAdditionalFlows, setOpenAdditionalFlows] = useState(false);


  const [flows, setStreams] = useState([]);
  const [additionalFlows, setAdditionalFlows] = useState([]);
  const [additionalFlowsPresense, setAdditionalFlowsPresense] = useState(false);

  const updatePlayerMeta = async (stream_name) => {
    let currentStream;
    if (stream_name) {
      currentStream = stream_name;
    } else if (flow.length > 0 && flowsInfo[flow.title.trim()]) {
      currentStream = flow.title.trim();
    } else if (lastListenedStream) {
      currentStream = lastListenedStream.trim();
    } else {
      currentStream = "В Эфире";
    }
    // console.log("flowsInfo", flowsInfo);
    if (Object.keys(flowsInfo).length > 0) {
      if (flowsInfo[currentStream]) {
        if (flowsInfo[currentStream].hasOwnProperty("artist")) {
          dispatch(setCurrentArtist(flowsInfo[currentStream].artist));
        } else {
          dispatch(setCurrentArtist(""));
        }

        if (flowsInfo[currentStream].hasOwnProperty("title")) {
          dispatch(setCurrentSong(flowsInfo[currentStream].title));
        } else {
          dispatch(setCurrentSong(currentStream));
        }

        if (flowsInfo[currentStream].hasOwnProperty("cover")) {
          dispatch(setCurrentCover(flowsInfo[currentStream].cover));
        } else {
          dispatch(setCurrentCover("/uploads/images/tracks/novoe_radio_placeholder.jpeg"));
        }
      } else {
        dispatch(setCurrentArtist(""));
        dispatch(setCurrentSong(currentStream));
        dispatch(setCurrentCover("/uploads/images/tracks/novoe_radio_placeholder.jpeg"));
      }
    } else {
      dispatch(setCurrentArtist(""));
      dispatch(setCurrentSong(currentStream));
      dispatch(setCurrentCover("/uploads/images/tracks/novoe_radio_placeholder.jpeg"));
    }

    // setCurrentArtist(Object.keys(flowsInfo).length > 0 ? flowsInfo[currentStream] ? flowsInfo[currentStream].artist : "" : "");
    // setCurrentSong(Object.keys(flowsInfo).length > 0 ? flowsInfo[currentStream] ? flowsInfo[currentStream].title : "" : "");
    // setCurrentCover(Object.keys(flowsInfo).length > 0 ? flowsInfo[currentStream] ? flowsInfo[currentStream].cover : "" : "");
  }

  const processingRequest = async () => {
    const allStreams = (await getAudioStreams()).data;
    if (allStreams.length > 5) {
      const [first, second, third, fourth, fifth, ...rest] = allStreams;
      setStreams([first, second, third, fourth, fifth]);
      setAdditionalFlows([...rest]);
      setAdditionalFlowsPresense(true);
    } else {
      setStreams(allStreams);
      setAdditionalFlowsPresense(false);
    }
    //setStreams((await getAudioStreams()).data);
    setSocialLinks((await getSocialLinks()).data);
  };

  useEffect(() => {
    processingRequest();
  }, []);

  useEffect(() => {
      updatePlayerMeta();
  }, [flowsInfo]);

  // useEffect(() => {
  //   updatePlayerMeta();
  // }, [Object.values(flowsInfo)]);
  // console.log("BlockPlayer flowsInfo", flowsInfo);

  // const updatePlayerMeta = (stream_name) => {
  //   if (Object.keys(flowsInfo).length > 0) {
  //     if (flowsInfo[stream_name.trim()]) {
  //       if (flowsInfo[stream_name.trim()].hasOwnProperty("artist")) {
  //         dispatch(setCurrentArtist(flowsInfo[stream_name.trim()].artist));
  //       } else {
  //         dispatch(setCurrentArtist(""));
  //       }
  //     } else {
  //       dispatch(setCurrentArtist(""));
  //     }
  //   } else {
  //     dispatch(setCurrentArtist(""));
  //   }

  //   if (Object.keys(flowsInfo).length > 0) {
  //     if (flowsInfo[stream_name.trim()]) {
  //       if (flowsInfo[stream_name.trim()].hasOwnProperty("title")) {
  //         dispatch(setCurrentSong(flowsInfo[stream_name.trim()].title));
  //       } else {
  //         dispatch(setCurrentSong(stream_name.trim()));
  //       }
  //     } else {
  //       dispatch(setCurrentSong(stream_name.trim()));
  //     }
  //   } else {
  //     dispatch(setCurrentSong(stream_name.trim()));
  //   }

  //   if (Object.keys(flowsInfo).length > 0) {
  //     if (flowsInfo[stream_name.trim()]) {
  //       if (flowsInfo[stream_name.trim()].hasOwnProperty("cover")) {
  //         dispatch(setCurrentCover(flowsInfo[stream_name.trim()].cover));
  //       } else {
  //         dispatch(setCurrentCover("/uploads/images/tracks/novoe_radio_placeholder.jpeg"));
  //       }
  //     } else {
  //       dispatch(setCurrentCover("/uploads/images/tracks/novoe_radio_placeholder.jpeg"));
  //     }
  //   } else {
  //     dispatch(setCurrentCover("/uploads/images/tracks/novoe_radio_placeholder.jpeg"));
  //   }

  //   // setCurrentArtist(Object.keys(flowsInfo).length > 0 
  //   // ? flowsInfo[stream_name.trim()] && flowsInfo[stream_name.trim()].hasOwnProperty("artist") 
  //   // ? flowsInfo[stream_name.trim()].artist 
  //   // : "" 
  //   // : "");
  //   // setCurrentSong(Object.keys(flowsInfo).length > 0 
  //   // ? flowsInfo[stream_name.trim()] && flowsInfo[stream_name.trim()].hasOwnProperty("title") 
  //   // ? flowsInfo[stream_name.trim()].title 
  //   // : stream_name.trim() 
  //   // : stream_name.trim());
  //   // setCurrentCover(Object.keys(flowsInfo).length > 0 
  //   // ? flowsInfo[stream_name.trim()] && flowsInfo[stream_name.trim()].hasOwnProperty("cover") 
  //   // ? flowsInfo[stream_name.trim()].cover 
  //   // : "/uploads/images/tracks/novoe_radio_placeholder.jpeg" 
  //   // : "/uploads/images/tracks/novoe_radio_placeholder.jpeg");
  // };

  // useEffect(() => {
  //   updatePlayerMeta(flow.title ? flow.title : "В Эфире");
  // }, [flow, currentFlowsInfo]);

  function setPlayerBurgerHandler() {
    setPlayerBurger((prev) => {
      if (prev === 'player-burger__active') {
        return '';
      }
      return 'player-burger__active';
    });
  }

  function burgerHandler() {
    dispatch(setMenuOpen(!isMenuOpen));
    setPlayerBurgerHandler();
  }

  const getClass = (item) => ( audioPlayback && flow.title === item ? 'flows-item_active' : '');

  const renderFlows = flows.map((item) => (
    <div
      aria-hidden
      className={`flows-item ${getClass(item.title)}`}
      key={item.title}
      onClick={async () => {
        // console.log(item);
        dispatch(changeAudioFlowAction(item.link));
        // sendAudioFlow(item.link);
        dispatch(changeFlowAction(item));
        dispatch(setStreamName(item.name));
        dispatch(setLastListenedStream(item.title.trim()));
        setActiveFlow(item);
        setplayingStation(item.name);
        // setPlayerBurger('');
        updatePlayerMeta(item.title.trim());

        if (audioPlayback && item.title === flow.title) {
          dispatch(pauseAudioPlaybackAction());
        }
        if (!audioPlayback) {
          dispatch(playAudioPlaybackAction());
        }

        if (window.outerWidth < 1200) {
          burgerHandler();
        }
      }}
    >
      {item.title}
      <div
        aria-hidden
        className="flow-item__control"
        onClick={(event) => {
          new Animation(event).button();
        }}
      >
      { getClass(item.title) ? (
        <SvgMiniPlayerPause />
      ) : (
        <SvgMiniAudio />
      )}
      </div>
    </div>
  ));

  const renderAdditionalFlows = additionalFlows.map((item) => (
    <div
      aria-hidden
      className={`flows-item ${getClass(item.title)}`}
      key={item.title}
      onClick={async () => {
        dispatch(changeAudioFlowAction(item.link));
        dispatch(changeFlowAction(item));
        dispatch(setStreamName(item.name));
        dispatch(setLastListenedStream(item.title.trim()));
        setActiveFlow(item);
        setplayingStation(item.name);
        setPlayerBurger('');
        updatePlayerMeta(item.title);

        if (audioPlayback && item.title === flow.title) {
          dispatch(pauseAudioPlaybackAction());
          
        }
        if (!audioPlayback) {
          dispatch(playAudioPlaybackAction());
        }

        // if (window.outerWidth < 1200) {
        //   setPlayerBurgerHandler();
        // }
      }}
    >
      {item.title}
      <div
        aria-hidden
        className="flow-item__control"
        onClick={(event) => {
          new Animation(event).button();
        }}
      >
      { getClass(item.title) ? (
        <SvgMiniPlayerPause />
      ) : (
        <SvgMiniAudio />
      )}
      </div>
    </div>
  ));

  return (
    <div
      className={`player-block player-open ${playerBurger}`} //${open ? 'player-open ' : ''}
    >
      <div className="player-row">
        <PlayerAudio/>  {/*title={currentSong} author={currentArtist}  src={currentCover}*/}
        <div className={`flows-container ${playerBurger}`}>
          {renderFlows}
          {additionalFlowsPresense ? (
            <div class = "flows-container_additional">
              <div
                aria-hidden
                className="hide-additional-flows"
                onClick={(event) => {
                  //new Animation(event).button();
                  setOpenAdditionalFlows(!openAdditionalFlows);
                }}
                style={
                  openAdditionalFlows
                    ? { transform: 'rotate(0deg)' , transition: 'all 0.3s linear'}
                    : { transform: 'rotate(180deg)', transition: 'all 0.3s linear' }
                }>
                <SvgArrow color="green" direction="up"></SvgArrow>
              </div>
              <div class = "flows_additional"
              style={
                openAdditionalFlows
                  ? { height: `64px`, transition: 'all 0.3s linear'}
                  : { height: '0', transition: 'all 0.3s linear' }
              }
              >{renderAdditionalFlows}</div>
            </div>
          ) : (
            <div></div>
          )}
          <PlayerVideo />
          <div class = "social_links_hidden">
            {socialLinks.map((el, index) => (
                <div
                  key={index.toString()}
                  className="banner__link-item"
                >
                  <a
                    href={el.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={el.picture}
                      alt={el.title}
                      className="social-img"
                    />
                  </a>
                </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`player-burger ${playerBurger}`}
        onClick={burgerHandler}
        aria-hidden
      >
        <span />
      </div>
      <Volume />
    </div>
  );
}

BlockPlayer.propTypes = {
  open: PropTypes.bool,
};

BlockPlayer.defaultProps = {
  open: false,
};
